import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {language} from '../../../language/vn';

@Component({
  selector: 'egov-chat',
  templateUrl: './chat.component.html',
  encapsulation: ViewEncapsulation.None
})
export class EgovChatComponent implements OnInit, AfterViewInit {

  public language = language;
  constructor(
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {

  }


}

